import CodeMirror from "codemirror";

// Just use Haskell mode for now.
CodeMirror.defineMIME("text/x-purescript", "haskell");
